import styled from "styled-components";
export const Pages = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
`;
export const StyledContainer = styled.div`
  padding: 0 8rem;
  display: flex;
  @media (max-width: 1300px) {
    width: auto;
    padding: 0 2rem;
  }
  @media (max-width: 1082px) {
    width: auto;
    padding: 0px 12px;
  }
  @media (max-width: 698px) {
    width: 100%;
    padding: 0px 5px;
  }
  @media (max-width: 573px) {
    width: 100%;
    padding: 0;
  }
  @media (max-width: 370px) {
    width: 100%;
    padding: 0;
  }
  @media (max-width: 320px) {
    width: 100%;
    padding: 0;
  }
`;
